//Componentes a los cuales se va dar acceso en la navegacion 
import Login from '../Componentes/Seguridad/Login';
import RecuperarContrasena from '../Componentes/Seguridad/RecuperarContrasena';
import RecuperarContrasenaSatisfactorio from '../Componentes/Seguridad/RecuperarContrasenaSatisfactorio';
import CambioContrasena from '../Componentes/Seguridad/CambioContrasena';
import Home from '../Componentes/Home/Home';
import NotFound from '../Componentes/NotFound/NotFound';

import { GnlNombreModulo } from './Llaves/RepositorioConfig';

const RutasComponente = {
    Rutas: [
        {
            component: Home,
            path: "/home/Inicio",
            opt: "Inicio",
            menu: "Inicio",
            descripcion: "Inicio",
            imgClass: "home",
            disabled: false
        }
    ],
    RutaLogin: {
        component: Login,
        path: "/auth/login",
        opt: "Login"
    },
    RutaHome: {
        component: Home,
        path: "/home/home",
        opt: "Home"
    },
    RutaNotFound: {
        component: NotFound,
        path: "/auth/NotFound",
        opt: "NotFound"
    },
    RutaRecorevyPassword: {
        component: RecuperarContrasena,
        path: "/auth/recovery",
        opt: "Recovery"
    },
    RutaRecorevyPasswordSussed: {
        component: RecuperarContrasenaSatisfactorio,
        path: "/auth/recoverySussed",
        opt: "RecoverySussed"
    },
    RutaChangePassword: {
        component: CambioContrasena,
        path: "/auth/changePassword/:controlchangeid",
        opt: "ChangePassword"
    },
    Modulo: GnlNombreModulo
};

export default RutasComponente;